import i18next from 'i18next';

i18next.addResources('es', 'articleThemeSelector', {
  allThemes: 'Temas',
  bim: 'BIM',
  blockchain: 'Blockchain',
  artificialintelligence: 'Inteligencia Artificial',
  iot: 'Internet de las Cosas',
  bigdata: 'Big Data'
});

i18next.addResources('en', 'articleThemeSelector', {
  allThemes: 'Themes',
  bim: 'BIM',
  blockchain: 'Blockchain',
  artificialintelligence: 'Artificial Intelligence',
  iot: 'Internet of Things',
  bigdata: 'Big Data'
});

i18next.addResources('pt', 'articleThemeSelector', {
  allThemes: 'Temas',
  bim: 'BIM',
  blockchain: 'Blockchain',
  artificialintelligence: 'Inteligência Artificial',
  iot: 'Internet das Coisas',
  bigdata: 'Big Data'
});
